module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-accountLocker"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('account_lockerTip'),
      "url": "/opera/account"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "whiteBox "
  }, [_c('a', {
    staticClass: "mint-cell"
  }, [_c('div', {
    staticClass: "mint-cell-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-wrapper"
  }, [_c('div', {
    staticClass: "mint-cell-title"
  }, [_c('span', {
    staticClass: "mint-cell-text"
  }, [_vm._v(_vm._s(_vm.$t('accountLocker_1')))])]), _vm._v(" "), _c('mt-switch', {
    on: {
      "change": _vm.changeSet
    },
    model: {
      value: (_vm.locker),
      callback: function($$v) {
        _vm.locker = $$v
      },
      expression: "locker"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-right"
  })]), _vm._v(" "), (_vm.locker) ? _c('a', {
    staticClass: "mint-cell"
  }, [_c('div', {
    staticClass: "mint-cell-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-wrapper",
    on: {
      "click": _vm.changeLocker
    }
  }, [_c('div', {
    staticClass: "mint-cell-title"
  }, [_c('span', {
    staticClass: "mint-cell-text"
  }, [_vm._v(_vm._s(_vm.$t('accountLocker_2')))])]), _vm._v(" "), _c('i', {
    staticClass: "mint-cell-allow-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-right"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("\n   " + _vm._s(_vm.$t('accountLocker_tip')) + "\n ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-43eb2433","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/accountLocker.vue
// module id = 1777
// module chunks = 107